export const defaultPublicAdminLogo = require('../../../assets/images/cards/teia-card-header/logo.png');
